import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'

import * as common from '../../../../../common'
import type { Expression } from '../../expression'
import type * as expressionNode from '../../node'
import type { FnHelper } from '../helper'
import { Key } from '../key'
import * as fnNode from '../node'

import {
  CommonArgs,
  removeIsolatedValueNodes,
  standardNodeCreator,
} from './utils'

/**
 * TODO ({ key: string; value: any }[] -> object)
 *
 * @param todo TODO
 * @example
 * TODO
 * // ->
 * TODO
 */
export interface LessThanOrEqualTo<out T = any> {
  /** {@link LessThanOrEqualTo} */
  readonly [Key.LessThanOrEqualTo]: T extends boolean
    ? readonly Expression<any>[]
    : never
}
export namespace LessThanOrEqualTo {
  export const isLessThanOrEqualTo: TypeChecker<LessThanOrEqualTo> =
    TypeChecker.Factory.lazy(() =>
      TypeChecker.Factory.object<LessThanOrEqualTo>({
        [Key.LessThanOrEqualTo]: CommonArgs.isListOfExpressions,
      }),
    ).usingAlias('Fn.LessThanOrEqualTo')
  export const assertIsLessThanOrEqualTo: TypeAsserter<LessThanOrEqualTo> =
    TypeAsserter.Factory.from(isLessThanOrEqualTo)

  /**
   * @see {@link Node}
   */
  export class Node<T extends boolean = boolean> extends fnNode.Node<
    T,
    Key.LessThanOrEqualTo,
    readonly expressionNode.Node[]
  > {
    public readonly type = common.value.types.Intrinsic.Boolean

    constructor(arg: Node<T>['arg']) {
      super(Key.LessThanOrEqualTo, arg)
    }
  }
  export namespace Node {
    export const isNode: TypeChecker<Node> = TypeChecker.Factory.instance(Node)
    export const assertIsNode: TypeAsserter<Node> =
      TypeAsserter.Factory.from(isNode)
  }

  const expressionsInArgs: FnHelper<LessThanOrEqualTo>['expressionsInArgs'] =
    fn => fn[Key.LessThanOrEqualTo]
  export const HELPER: FnHelper<LessThanOrEqualTo> = {
    createNode: standardNodeCreator.comparison({
      compare: (a, b) => a <= b,
      getArgExpressions: expressionsInArgs,
      nodeClass: Node,
    }),
    expressionsInArgs,
    typeChecker: isLessThanOrEqualTo,
  }
}
